"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDynamicFilters = void 0;
const mapDynamicFilters_1 = require("./mapDynamicFilters");
function buildDynamicFilters(builder, filterPanelLabel, dynamicColumnData) {
    var _a, _b, _c, _d, _e;
    if (dynamicColumnData) {
        const columnDefs = dynamicColumnData.columnDefs.filter((columnDef) => { var _a; return (_a = columnDef.metadata) === null || _a === void 0 ? void 0 : _a.showInFilters; });
        if (columnDefs.length > 0) {
            const children = [];
            for (const columnDef of columnDefs) {
                const key = `_dynamic_${columnDef.name}`;
                const label = (_b = (_a = columnDef.metadata) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : '';
                const values = (0, mapDynamicFilters_1.mapHandlerToValues)(dynamicColumnData.handlerMap.get((_d = (_c = columnDef.metadata) === null || _c === void 0 ? void 0 : _c.columnHandlerName) !== null && _d !== void 0 ? _d : ''));
                switch (columnDef.type) {
                    case 'boolean':
                        children.push(builder.allFiltersWidget({
                            type: 'form.checkbox',
                            key,
                            label,
                        }));
                        break;
                    case 'number':
                        // interesting "if", is there a better way?
                        if ((_e = columnDef.metadata) === null || _e === void 0 ? void 0 : _e.columnHandlerName.toLowerCase().includes('date')) {
                            children.push({
                                type: 'form.panel',
                                children: [
                                    builder.allFiltersWidget({
                                        type: 'form.datePicker',
                                        key: key + '_after',
                                        label: label + ' After',
                                    }),
                                    builder.allFiltersWidget({
                                        type: 'form.datePicker',
                                        key: key + '_before',
                                        label: label + ' Before',
                                    }),
                                ],
                                style: { layout: 'row' },
                            });
                        }
                        else if (values) {
                            children.push(builder.allFiltersWidget(filterWithValues(key, label, values)));
                        }
                        else {
                            children.push(builder.allFiltersWidget({
                                type: 'form.number',
                                key,
                                label,
                            }));
                        }
                        break;
                    case 'number-array':
                        if (values) {
                            children.push(builder.allFiltersWidget(filterWithValues(key, label, values)));
                        }
                        else {
                            children.push(builder.allFiltersWidget({
                                type: 'form.number',
                                key,
                                label,
                            }));
                        }
                        break;
                    case 'string':
                        if (values) {
                            children.push(builder.allFiltersWidget(filterWithValues(key, label, values)));
                        }
                        else {
                            children.push(builder.allFiltersWidget({
                                type: 'form.text',
                                key,
                                label,
                                emptyAsNull: true,
                            }));
                        }
                        break;
                    case 'string-array':
                        if (values) {
                            children.push(builder.allFiltersWidget(filterWithValues(key, label, values)));
                        }
                        else {
                            children.push(builder.allFiltersWidget({
                                type: 'form.text',
                                key,
                                label,
                                emptyAsNull: true,
                            }));
                        }
                        break;
                    case 'id':
                        children.push(builder.allFiltersWidget(filterWithValues(key, label, values)));
                        break;
                    case 'id-array':
                        children.push(builder.allFiltersWidget(filterWithValues(key, label, values)));
                        break;
                    case 'full-text-search':
                        children.push(builder.allFiltersWidget({
                            type: 'form.text',
                            key,
                            label,
                            emptyAsNull: true,
                        }));
                        break;
                }
            }
            return {
                key: '!customFilters', // This key can be used by other products to extend/modify account filters.
                label: filterPanelLabel,
                children: children.flatMap((child, index) => (index === 0 ? [child] : [{ type: 'form.divider' }, child])),
            };
        }
        else {
            return undefined;
        }
    }
    else {
        return undefined;
    }
}
exports.buildDynamicFilters = buildDynamicFilters;
function filterWithValues(key, label, values) {
    if (values && values.length <= 20) {
        return {
            type: 'form.checkboxList',
            key,
            label,
            values,
            style: {
                layout: '2-columns-stretch',
            },
        };
    }
    else {
        return {
            type: 'form.multiSelect',
            key,
            label,
            values: values !== null && values !== void 0 ? values : [],
        };
    }
}
